import { result, isUndefined, isEmpty } from 'lodash';

export const getSelector = (pathFromState) => (state) => result(state, pathFromState, null);

export const getRoomHistory = () => {
	const item = localStorage.getItem('features/recent-list')
	return (item !== null) ? JSON.parse(item).reverse() : []
}

export const validateEmail = (email) => {
	const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(String(email).toLowerCase());
}

export const charectorLength = (input) => {

	if (!isUndefined(input)) {
		let max_length = 15;
		let this_length = max_length - input.toString().length;
		if (this_length < 0) {
			let sub = input.substr(0, 15);
			let res = `${sub}...`
			return res;
		} else {
			console.log('ตัวอักษร', this_length)
		}
	}
}

export const isValidName = (name) => {
	if (!name.trim()) {
		return false
	}

	//let reg = /^(?!.*(?:&|:|'|"|%|#|\/|\\|\$|\^|\*|`|>|<|\?)).+/
	let reg = /^[a-zA-Z0-9ก-๙_-\s]+$/i
	return reg.test(name)
}

export const validateMobileNation = mobile => {
	let m = mobile.split(' ');
	if (m.length > 0) {
		if ('+66' === m[0]) {
			if (m.join('').length >= 12) {
				return true;
			} else {
				return false;
			}
		} else {
			return true;
		}
	} else {
		return false;
	}
};

export const uploadImageValidate = (type, size) => {
	if (type.search("image/") >= 0 && type !== "image/gif") {
		return true
		// let s = size.split(" ");
		// if (s.length > 1) {
		// 	if (parseInt(s[0]) <= 2048) {
		// 		return true;
		// 	}
		// }
	} else {
		return false;
	}
};

export function randomNum() {
	let length = 32;
	let result = "";
	let characters =
		"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	let charactersLength = characters.length;
	let i;
	for (i = 0; i < length; i++)
		result += characters.charAt(Math.floor(Math.random() * charactersLength));

	// setOTPState(result);
	return result;
}


const monthFullTh = month => {
	switch (month) {
		case "01":
			return "มกราคม";
		case "02":
			return "กุมภาพันธ์";
		case "03":
			return "มีนาคม";
		case "04":
			return "เมษายน";
		case "05":
			return "พฤษภาคม";
		case "06":
			return "มิถุนายน";
		case "07":
			return "กรกฎาคม";
		case "08":
			return "สิงหาคม";
		case "09":
			return "กันยายน";
		case "10":
			return "ตุลาคม";
		case "11":
			return "พฤศจิกายน";
		case "12":
			return "ธันวาคม";
		default:
			return "-";
	}
}

const monthFullEn = month => {
	switch (month) {
		case "01":
			return "January";
		case "02":
			return "February";
		case "03":
			return "March";
		case "04":
			return "April";
		case "05":
			return "May";
		case "06":
			return "June";
		case "07":
			return "July";
		case "08":
			return "August";
		case "09":
			return "September";
		case "10":
			return "October";
		case "11":
			return "November";
		case "12":
			return "December";
		default:
			return "-";
	}
};


const monthFullCn = month => {
	switch (month) {
		case "01":
			return "一月";
		case "02":
			return "二月";
		case "03":
			return "三月";
		case "04":
			return "四月";
		case "05":
			return "五月";
		case "06":
			return "六月";
		case "07":
			return "七月";
		case "08":
			return "八月";
		case "09":
			return "九月";
		case "10":
			return "十月";
		case "11":
			return "十一月";
		case "12":
			return "十二月";
		default:
			return "-";
	}
};




export const formatDateThai = (date, language) => {
	const d = new Date(date)
	const m = d.getMonth() + 1
	if (language === "th") {
		return `${d.getDate()} ${monthFullTh(m.toString().padStart(2, '0'))} ${d.getFullYear() + 543}`
	} else if (language === "cn") {
		return `${d.getDate()} ${monthFullCn(m.toString().padStart(2, '0'))} ${d.getFullYear()}`
	} else {
		return `${d.getDate()} ${monthFullEn(m.toString().padStart(2, '0'))} ${d.getFullYear()}`
	}
}

export const isFetchReserve = () => {
	if (isEmpty(window._env_.isFetchtReservList) || parseInt(window._env_.isFetchtReservList) === 1) {
		return true
	}
	return false
}

export function getBackendSafeRoomName(room) {
	if (!room) {
		return room;
	}
	try {
		room = decodeURIComponent(room);
	} catch (e) {

	}

	// Normalize the character set.
	room = room.normalize('NFKC');

	// Only decoded and normalized strings can be lowercased properly.
	room = room.toLowerCase();

	// But we still need to (re)encode it.
	room = encodeURIComponent(room);
	return room.toLowerCase();
}

export function formatNumberTwo(d) {
	return (parseInt(d) < 10) ? '0' + d : d;
}

export function formatSizeUnits(bytes){
	if (bytes >= 1073741824) { 
		bytes = (bytes / 1073741824).toFixed(2) + " GB"; 
	} else {
		bytes = (bytes / 1048576).toFixed(2) + " MB";
	}
	return bytes;
}

export function byteToMbGb(bytes){
	if (bytes >= 1073741824) { 
		bytes = (bytes / 1073741824).toFixed(2) + " GB"; 
	} else {
		bytes = (bytes / 1048576).toFixed(2) + " MB";
	}
	return bytes;
}

function toFixedNorounding(figure, decimals){
	if (!decimals) decimals = 2;
	var d = Math.pow(10,decimals);
	return (parseInt(figure*d)/d).toFixed(decimals);
};

export function byteToGb(bytes){
	return  toFixedNorounding((bytes / 1073741824), 2) + " GB";
}

// shared threshold so the warning banner and red progress bar never drift apart
export const RECORD_STORAGE_WARNING_PERCENT = 90

// normalise a usage percentage into 0-100, guarding bad API values (negative, NaN, non-numeric)
export function clampPercent(value) {
	const n = Number(value)
	if (!Number.isFinite(n) || n < 0) return 0
	return n > 100 ? 100 : n
}

export function getLanguageConference () {
	if(!localStorage.getItem('language')) return null
	
	const lang = localStorage.getItem('language') === 'zhCN' ? 'cn' : localStorage.getItem('language')
	return lang
}

export function setLanguageConference (lang) {	
	const lng = lang === 'cn' ? 'zhCN' : lang
	localStorage.setItem('language', lng)
}